//borrar TipoPlan
const TipoPlan = {
    PlanInternet: "planInt",
    ServicesGen: "servGen",
    Articulo: "art",
};

const UnidAnchoBanda = {
    Megas: "ME",
    Gigas: "GI",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
};

export {UnidAnchoBanda, TipoPlan, Udm, Moneda };
